export default "__VITE_ASSET__DSBagM1p__"